import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cfunction() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
  return (
    <div>
       
      <Sides/>
       <Helmet>
 
 <title>Function in c++ tutorial For Beginners</title>
 <meta name="description" content="Function in c++ tutorial for beginners.Function in c++ is a set of statements enclosed in {} written under name,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,Function in c++ tutorial for beginners,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,cpp function,c++ in function,for function c++,c++ function pointer,cpp function prototype,cpp function declaration,c++ function call,c++ function exit,cpp function in r,c++ function program" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-function" />
 </Helmet>

 <div className='lg:pl-56'>

      <h1 className="m-4 mh1">Function in C++</h1>
      <div className="first">
        <a href="/cpp-array">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-user-defined-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
      <p className="para mt-4">1, Function in c++ is a set of statements enclosed in {} written under a name.<br />
2, A function is defined only one time and can be used for only no time.<br />

3, With the help of a function, a big program can be more flexible.<br />
      </p>

      <h2 className="mt-4 mh2">Types of function in c++ programming language:
</h2>
      <h3 className="mt-4 mh3">1,Library function <br />
2,User defined function<br />
      </h3>
      <h4 className="mt-4">1,Library function in c++-</h4>
      <p className="mt-4 para">library function in c++ these function are pre-defined function in the library of c++.if we want to use an library function then we have to include its header file at the top of the programme<br />
&#60;stdio.h&#62;<br />
 printf()<br />
gets()<br />
Getchar()<br />
Scanf()<br />
Puts()<br />
Putchar()<br />
Etc.<br />
      </p>



      <h2 className='headings'>Q-Math sqrt() by using function in c++ programming language?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">math.h</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-11"> double </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">,</span>
              <span className="qwerty">a</span>
              <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-10"> i </span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-2"> 24 </span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty"> a </span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">sqrt </span>
              <span className="qwerty-3">(</span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">) ;</span>
            {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2"> Square Root is </span>
            <span className="qwerty-3"> " &#60;&#60;</span>
              <span className="qwerty"> a</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">Square Root is  </span>
              <span className="qwerty">4.89898 </span>
             
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


      <h2 className="mt-4 mh2">Exit(0):</h2>

      <p className="mt-4 para">&#60;stdlib.h&#62;<br />
&#60;process.h&#62;<br />
This position uses to terminate the program correctly.

</p>

     

      <h2 className='headings'>Q-Exit using a function in c++ programming language?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdlib.h</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
         
       
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2"> Program Exit 1 </span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty"> exit </span>
              <span className="qwerty-3">(</span>
              <span className="qwerty-10">0</span>
              <span className="qwerty-3">);</span>
            {"\n"}
            <span className="qwerty-4"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2"> Program Exit 2 </span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">Program Exit </span>
              <span className="qwerty">1 </span>
   
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


      <h2 className="mt-4 mh2">Character Function:
</h2>
      <p className="mt-4 para">
        Getchar()-to input a single character<br />
        Getche()- input character and echo<br />
        Getch()- input  character without echo<br />
</p>
      <h3 className="mt-4">Getchar() function in C++:</h3>
   

      <h2 className='headings'>Q-Write a program use getchar() in c++ function?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code >{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-5">main </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-4"> char</span>
            <span className="qwerty-2"> ch </span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2"> enter a char </span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-4"> ch </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-2">getchar </span>
              <span className="qwerty-3">();</span>
            {"\n"}
            <span className="qwerty"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
              <span className="qwerty-3">*";</span>
            {"\n"}
            <span className="qwerty"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2"> \n you entered </span>
            <span className="qwerty-3"> = "&#60;&#60;</span>
            <span className="qwerty-2"> ch </span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">enter a </span>
              <span className="qwerty">character </span>
              <span className="qwerty-4">v</span>
              {"\n"}   
              <span className="qwerty-3">* </span>
              {"\n"} 
              <span className="qwerty-11">you entered </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-4">v </span>
           
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>

      <h4 className="mt-4">Getche() function in C++: </h4>

      <h2 className='headings'>Q-Write a program use getche() in c++ function ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdio.h</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">conio.h</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-4">int </span>
            <span className="qwerty-5">main </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty"> char</span>
            <span className="qwerty-4"> ch</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty"> printf </span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-2">enter a char</span>
              <span className="qwerty-3">");</span>
            {"\n"}
            <span className="qwerty-4"> ch </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-2">getche</span>
              <span className="qwerty-3">();</span>
            {"\n"}
            <span className="qwerty"> printf </span>
            <span className="qwerty-3">("*");</span>
            {"\n"}
            <span className="qwerty"> printf </span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-2">\n you entered </span>
            <span className="qwerty-3"> = %</span>
            <span className="qwerty-2"> c</span>
              <span className="qwerty-3">",</span>
              <span className="qwerty-2"> ch</span>
              <span className="qwerty-3">);</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">enter a </span>
              <span className="qwerty">char</span>
              <span className="qwerty-4"> b</span>
              <span className="qwerty-3"> * </span>
              {"\n"} {"\n"}
              <span className="qwerty-11">you entered </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">b </span>
              {"\n"}
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


      <h3 className="mt-4">Getch() Function in C++ :</h3>

  


      <h2 className='headings'>Q-Write a program use getch() in c++ function ?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code >{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">stdio.h</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">conio.h</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-4">void </span>
            <span className="qwerty-5">main </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty"> char</span>
            <span className="qwerty-4"> ch</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty"> printf </span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-2">enter a char</span>
              <span className="qwerty-3">");</span>
            {"\n"}
            <span className="qwerty-4"> ch </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-2">getch</span>
              <span className="qwerty-3">();</span>
            {"\n"}
            <span className="qwerty"> printf </span>
            <span className="qwerty-3">("*");</span>
            {"\n"}
            <span className="qwerty"> printf </span>
            <span className="qwerty-3">("</span>
            <span className="qwerty-2">\n you entered </span>
            <span className="qwerty-3"> = %</span>
            <span className="qwerty-2"> c</span>
              <span className="qwerty-3">",</span>
              <span className="qwerty-2"> ch</span>
              <span className="qwerty-3">);</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">enter a </span>
              <span className="qwerty">char</span>
              <span className="qwerty-3">* </span>
              {"\n"} {"\n"}
              <span className="qwerty-11">you entered </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty">k</span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>


      <h2 className="mt-4 mh2">*&#60;dos.h&#62;</h2>
      <h3 className="mt-4 mh3">1,Sleep()<br />
2,delay()<br />
      </h3>

      <p className="mt-4 para">Both functions use to pause the execution of the program for a fixed period.
</p>



      <h2 className='headings'>Q-Write a Program to print the no from 1 to 10 .using the interval of 1 second?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>{"            "}
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">unistd.h</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
           
            <span className="qwerty-4">int </span>
            <span className="qwerty-5">main </span>
            <span className="qwerty-3">() </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"} {"\n"}
            <span className="qwerty">  int</span>
            <span className="qwerty-2"> i</span>
              <span className="qwerty-3">;</span>
              {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}
            <span className="qwerty-11">  for </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">i</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-2"> 1</span>
              <span className="qwerty-3">;</span>
              <span className="qwerty-2"> i</span>
              <span className="qwerty-3">&#60;</span>
              <span className="qwerty-3">= </span>
            <span className="qwerty-2"> 10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-2"> i</span>
              <span className="qwerty-3">++)</span>
            {"\n"}
            <span className="qwerty-4">  cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-2">i </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-2">\n</span>
              <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-7">  sleep </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-2">i</span>
              <span className="qwerty-3">);</span>
              {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"} 
              <span className="qwerty-11">1</span>
              {"\n"}
              <span className="qwerty-11">2</span>
              {"\n"}
              <span className="qwerty-11">3</span>
              {"\n"}
              <span className="qwerty-11">4</span>
              {"\n"}
              <span className="qwerty-11">5</span>
              {"\n"}
              <span className="qwerty-11">6</span>
              {"\n"}
              <span className="qwerty-11">7</span>
              {"\n"}
              <span className="qwerty-11">8</span>
              {"\n"}
              <span className="qwerty-11">9</span>
              {"\n"}
              <span className="qwerty-11">10</span>
   
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


      <h1 className="mt-5">  </h1>
      <div className="back">
        <a href="/cpp-array"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-user-defined-function"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
  )

}
export default Cfunction;